import 'dayjs/locale/ru';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import {
  DAYS_OF_WEEK,
  DAYS_OF_WEEK_LABELS,
  DAYS_ORDER,
} from '@/shared/vaccination/enums';

const DateMapper = dayjs;

DateMapper.extend(customParseFormat);
DateMapper.extend(localizedFormat);
DateMapper.locale('ru');

export default DateMapper;

export enum DateTimeFormat {
  LOCAL_DATE = 'YYYY-MM-DD',
  LOCAL_DATE_TIME = 'YYYY-MM-DDTHH:mm:ss',
  DATE_TIME = 'DD.MM.YYYY HH:mm:ss',
  DATE_TIME_SHORT = 'DD.MM.YYYY HH:mm',
  DATE = 'DD.MM.YYYY',
  TIME = 'HH:mm:ss',
  TIME_SHORT = 'HH:mm',
  YEAR = 'YYYY',
}

export const getAcademicYearOptions = (before: number = 0, after: number = 5) => {
  const currentDate = DateMapper();
  const currentYear =
    currentDate.month() >= 8 ? currentDate.year() : currentDate.year() - 1;

  const startYear = currentYear - before;
  const endYear = currentYear + after;

  return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
    const year = startYear + i;
    const label = `${year}/${year + 1}`;
    return { label, value: label };
  });
};

export const mapDateToFormat = (date: string, format: string = DateTimeFormat.DATE) => {
  return DateMapper(date, DateTimeFormat.LOCAL_DATE).format(format);
};

export const sortDaysOfWeek = (days: DAYS_OF_WEEK[]) =>
  [...days].sort((a, b) => (DAYS_ORDER[a] ?? 999) - (DAYS_ORDER[b] ?? 999));
